'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../../common/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;
var _default = {
	colors: colors,
	body: {
		fontFamily: 'Open Sans',
		width: '90%',
		display: 'flex',
		flexDirection: 'column',
		margin: '40px auto 0',
		fontSize: '14px',

		'@media screen and (max-width: 768px)': {
			fontSize: '12px'
		},

		'@media screen and (max-width: 550px)': {
			fontSize: '10px'
		}
	},
	pageTitle: function pageTitle(isLoading) {
		return {
			fontSize: '2.42em',
			textAlign: isLoading ? 'center' : 'left'
		};
	},
	loader: {
		margin: '0 auto',
		display: 'block'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMCompanyPage/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPage/styles/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPage/styles/index.js
// module id = 1MJl
// module chunks = 62 63